<div class="overflow-hidden flex gap-2" [class]="!isOverview() ? 'shadow-xl rounded-3xl h-[300px]' : 'h-[232px]'">
  @for (item of currentPageImageUrls(); track item.url) {
    <app-image-preview class="basis-[75%] first:basis-[100%]" [url]="item.url"></app-image-preview>
  }
  @if (!currentPageImageUrls().length) {
    <app-image-preview class="basis-[75%] first:basis-[100%]" [url]="null"></app-image-preview>
  }
</div>

@if (!isOverview()) {
  <div class="flex justify-between items-center h-[65px]">
    @if (!isDraft()) {
      <ng-content></ng-content>
    } @else {
      @if (date()) {
        <div class="date">
          {{ date() }}
        </div>
      }
    }

    @if (pages().length > 1) {
      <div class="flex gap-2 justify-end">
        @for (page of pages(); track page) {
          <div class="h-3 rounded-full cursor-pointer" [class]="isPageActive(page) ? 'bg-blue w-7' : 'bg-gray w-3'"
               (click)="goPage(page)" aria-hidden="true"></div>
        }
      </div>
    }
  </div>
}
